import React, { useState, useEffect } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { Breadcrumb, Button, Modal } from "antd";
import { DoubleRightOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import AllVendorsTable from "./PurchaseTables/AllVendorsTable";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import PurchasePayment from "../../modals/purchasePaymentModal";
import plus from "../../assets/Images/plus.svg";
import AddVendor from "./AddVendor";
import { checkPermission } from "../../Utils/permissionHelper";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";

const AllVendors = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector((state) => state?.login?.user?.result?.company_id);
  const [loading, setloading] = useState(true);

  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [popup, setpopup] = useState(false);
  const [vendorID, setVendorId] = useState(null);
  const [showComponent, setShowComponent] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isSelectMode, setIsSelectMode] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [deleteVendorLoading, setDeleteVendorLoading] = useState(false);

  const getAllVendors = (text, currentLimit, currentOffset) => {
    fetchAllVendors(user_id, currentLimit, currentOffset, text).then(
      (datagot) => {
        setloading(false);
        setData(datagot);
      }
    );
  };

  const refreshVendorData = () => {
    getAllVendors(query, currentLimit, currentOffset);
  };

  const debouncedSearch = debounce((value) => {
    setloading(true);
    getAllVendors(value, 15, 0);
  }, 1200);

  const handlePaymentClick = (val) => {
    if (!checkPermission("/purchase/vendors")) {
      // toast.error("You do not have permission to perform this action.");
      return;
    }
    console.log("VADVSVDVSD", val);
    setVendorId(val?.id);
    setIsModalVisible(true);
  };

  const closeAddVendor = () => {
    setShowComponent(false);
    refreshVendorData();
                  setEditData(null)

  };


  const onEditLine =async(data)=>{
    setShowComponent(true);
    setEditData(data)
  }

  const toggleSelectVendor = (vendorId) => {
    setSelectedVendors((prev) =>
      prev.includes(vendorId)
        ? prev.filter((id) => id !== vendorId)
        : [...prev, vendorId],
    );
  };

  const handleSelectAllVendors = (checked) => {
    if (checked) {
      setSelectedVendors(data.map((vendor) => vendor.id));
    } else {
      setSelectedVendors([]);
    }
  };

  const handleExitSelectMode = () => {
    setIsSelectMode(false);
    setSelectedVendors([]);
  };

  const handleDeleteSelectedVendors = () => {
    Modal.confirm({
      title: t("Are you sure you want to delete the selected vendors?"),
      icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
      okText: t("Yes"),
      cancelText: t("No"),
      okButtonProps: {
        className: "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
      },
      onOk: async () => {
        try {
          setDeleteVendorLoading(true);
          const payload = {
            vendor_ids: selectedVendors,
            user_id: user_id,
          };
          const response = await axiosInstance.post(
            URLS.DELETE_VENDOR,
            payload,
          );
          if (response?.data?.result?.status_code == 200) {
            toast.success(t(response?.data?.result?.status));
            handleExitSelectMode();
            refreshVendorData();
          } else {
            toast.error(t(response?.data?.result?.status));
          }
        } catch (error) {
          console.error("Error deleting vendors:", error);
        } finally {
          setDeleteVendorLoading(false);
        }
      },
    });
  };

  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
        <SetHeading value="Vendor List" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden">
          <div className="font-extrabold mb-3 mx-5">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={
                showComponent
                  ? [
                    {
                      title: (
                        <span
                          className="cursor-pointer hover:bg-gray-200 hover:text-black"
                          onClick={() => {
                            setEditData(null);
                            setShowComponent(false);
                          }}
                        >
                          {t("Vendor List")}
                        </span>
                      ),
                      key: "all-vendors",
                    },
                    {
                      title: t("Add Vendor"),
                      key: "add-vendor",
                    },
                  ]
                : []
            }
            className="relative mt-3 font-semibold"
          />
        </div>

        {/* Search + Add Vendor Button */}
        <div className="flex flex-col md:flex-row justify-between gap-4 px-4 md:px-5">
          {/* Search Box */}
          {!showComponent && (
            <div className="w-full md:w-auto">
              <SearchBox
                searchResult={(values) => {
                  setquery(values);
                  debouncedSearch(values);
                }}
                placeholder={t("Search Vendors")}
                value={query}
              />
            </div>
          )}

          {/* Add New Vendor / Select Vendors Buttons */}
          {!showComponent && (
            <div className="flex w-full flex-col flex-wrap gap-2 sm:flex-row sm:items-center sm:justify-end md:w-auto">
              {!isSelectMode ? (
                <>
                {data?.length > 0 && 
                <button
                    onClick={() => {
                      if (checkPermission("/purchase/vendors")) {
                        setIsSelectMode(true);
                      }
                    }}
                    className="flex h-10 w-full shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-primaryBlue px-4 text-sm font-semibold text-primaryBlue md:w-auto"
                  >
                    {t("Delete Vendors")}
                  </button>}
                  
                  <button
                    onClick={() => {
                      if (checkPermission("/purchase/vendors")) {
                        setShowComponent(true);
                      }
                    }}
                    className="font-semibold w-full md:w-48 h-10 border rounded-lg bg-primaryBlue text-white text-base flex justify-center items-center gap-2"
                    type="submit"
                  >
                    <img src={plus} alt="plus" />
                    <p>{t("Add New Vendor")}</p>
                  </button>
                </>
              ) : (
                <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
                  <span className="whitespace-nowrap text-sm text-gray-500 italic">
                    {selectedVendors.length > 0
                      ? `${selectedVendors.length} ${t("vendor(s) selected")}`
                      : t("Select vendors to delete")}
                  </span>
                  <div className="flex shrink-0 gap-2">
                    <button
                      onClick={handleExitSelectMode}
                      className="h-10 shrink-0 whitespace-nowrap rounded-lg border border-gray-300 bg-white px-3 text-sm font-medium text-gray-600"
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      disabled={selectedVendors.length === 0 || deleteVendorLoading}
                      onClick={handleDeleteSelectedVendors}
                      className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg px-3 h-10 text-white text-sm font-semibold transition-opacity ${
                        selectedVendors.length === 0
                          ? "bg-[#D10000] opacity-40 cursor-not-allowed"
                          : "bg-[#D10000] hover:bg-[#e01414]"
                      }`}
                    >
                      {deleteVendorLoading ? t("Deleting...") : t("Delete Selected")}
                      {selectedVendors.length > 0 && (
                        <span className="bg-white text-[#D10000] text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                          {selectedVendors.length}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Vendor Table */}
        {!showComponent && (
          <div className="mt-4 px-4 md:px-3 overflow-x-auto">
            <AllVendorsTable
              loading={loading}
              additionalData={data}
              pagination={(values) => {
                console.log("All vendors");
                setCurrentLimit(values.limit);
                setCurrentOffset(values.offset);
                getAllVendors(
                  query,
                  values.limit,
                  values.offset
                );
              }}
              handlePaymentClick={handlePaymentClick}
              onEditLine={onEditLine}
              isSelectMode={isSelectMode}
              selectedVendors={selectedVendors}
              onToggleSelect={toggleSelectVendor}
              onSelectAll={handleSelectAllVendors}
            />
          </div>
        )}

        {/* Add Vendor Form */}
        {showComponent && (
          <div className="mt-4 px-4 md:px-3">
            <AddVendor
              onClose={() => {
                closeAddVendor();
              }}
              editData={editData}
              isEdit={editData ? true : false}
            />
          </div>
        )}

        {/* Payment Modal */}
        {isModalVisible && (
          <PurchasePayment
            isOpen={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            vendor_id={vendorID}
            page={"allVendors"}
            Popup={() => setpopup(true)}
            onPaymentSuccess={refreshVendorData}
            store_id={company_id}
          />
        )}
      </div>
    </div>
  </>
);
};

export default AllVendors;
